module.exports = __webpack_public_path__ + "img/wf.b053c851.png";